import type { FieldValue, IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';
import type { IValueText } from './IValueText';

/**
 * Значення поля одним рядком (уточнення в списках вибору, розширений пошук): варіант і статус — підписом мовою інтерфейсу,
 * особа — ім'ям, дата — «21 жовт.», число — з групуванням, так/ні, теги — через кому; посилання на запис (ідентифікатор) не показується.
 */
export function valueText(field: IFieldDefinition, rt: IRecordTypeDefinition, value: FieldValue | undefined, fmt: IValueText): string {
  if (value === null || value === undefined || value === '') return '';
  if (Array.isArray(value)) return value.map(String).join(', ');
  if (typeof value === 'object') return 'name' in value ? String((value as { name: unknown }).name ?? '') : '';
  switch (field.type) {
    case 'select': {
      if (field.key === 'status') return fmt.status(String(value), rt.statuses.list.find((s) => s.value === value)?.label);
      return fmt.option(field.key, String(value), field.options?.find((o) => o.value === value)?.label);
    }
    case 'date': return fmt.date(String(value));
    case 'number': return typeof value === 'number' ? fmt.number(value) : String(value);
    case 'boolean': return value ? fmt.yes : fmt.no;
    case 'ref': case 'lookup': case 'area': case 'iteration': case 'file': case 'user': return '';
    default: return String(value);
  }
}
